// @ts-check
import React from "react"
import Button from "../../atoms/Button.atom"
import PropTypes from "prop-types"
import { chooseButtonClass } from "../../../utils/buttons.utils"

/** @type {import("./SecondaryButton.molecule").SecondaryButton} */
export default function SecondaryButton({
  className,
  rounded = true,
  type,
  kind = "text",
  ...props
}) {
  return (
    <Button
      {...props}
      className={`p-button-secondary ${chooseButtonClass(kind)} ${rounded ? "border-round-3xl" : ""} ${className}`}
      type={type}
    />
  )
}

SecondaryButton.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["regular", "text", "outlined"]),
  rounded: PropTypes.bool,
  disabled: PropTypes.bool,
}
